export default [
    {
        id: 1,
        tag: 'Hot Deals',
        product: "ASTAR PREMIUM PARBOILED",
        image: 'https://www.sefalana.com/data/sefalana-trading/house-brands/astar/2/Astar%20Premium%20Parboiled%20Rice%20-%2010kg.jpg',
        weight:"MANY MORE IN-STORE"
    },
     {
        id: 2,
        tag: 'Dairy Products',
        product: "ASTAR FULL CREAM LONG",
        image: "https://www.sefalana.com/data/sefalana-trading/house-brands/astar/1/astar%20full%20cream%20long%20life%20milk%20500ml.jpg",
        weight:"LIFE MILK 500ML"
    },
     {
         id: 3,
        tag: 'Utensils',
        product: "ASTAR TABLESPOONS",
        image: "https://www.sefalana.com/data/sefalana-trading/house-brands/astar/3/Astar%20Tablespoons%206's.jpg",
        weight:"6'S"
    },
     {
        id: 4,
        tag: 'Grains',
        product: "ASTAR PREMIUM PARBOILED",
        image: "https://www.sefalana.com/data/sefalana-trading/house-brands/astar/2/Astar%20Premium%20Parboiled%20Rice%20-%2010kg.jpg",
        weight:"RICE - 10KG"
    },
];